import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { FilterXSS, escapeAttrValue, whiteList } from 'xss';
var options = {
  whiteList: _objectSpread(_objectSpread({}, whiteList), {}, {
    nobr: []
  }),
  onIgnoreTagAttr: function onIgnoreTagAttr(_, name, value) {
    if (['id', 'style', 'class'].includes(name) || name.substring(0, 5) === 'data-' || name.substring(0, 5) === 'aria-') {
      return "".concat(name, "=\"").concat(escapeAttrValue(value), "\"");
    }
    return undefined;
  }
};
var filterXss = new FilterXSS(options);
var sanitizeDangerousChildren = function sanitizeDangerousChildren(html) {
  return filterXss.process(html);
};
var regex = /(\r\n|\n|\r)/gm;
export var spreadDangerousChildren = function spreadDangerousChildren(children, allowHTML, allowLineFeed) {
  if (typeof children !== 'string' || !allowLineFeed && !allowHTML) {
    return {
      children: children
    };
  }
  if (allowHTML) {
    return {
      children: null,
      dangerouslySetInnerHTML: {
        __html: sanitizeDangerousChildren(allowLineFeed ? children.replace(regex, '<br />') : children)
      }
    };
  }
  return {
    children: children.split(regex).map(function (el, i) {
      return el.match(regex) ? /*#__PURE__*/React.createElement('br', {
        key: "br-".concat(i)
      }) : el;
    })
  };
};